module.exports = __webpack_public_path__ + "static/media/bg2.44d237ab.png";